import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dt__filter"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "dt-filterIcon" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Фильтры", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filter_panel = _resolveComponent("filter-panel")!

  return (this.filters.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (this.onOpen && this.onOpen(...args))),
          class: "dt__filter-button"
        }, [
          _hoisted_2,
          _hoisted_3,
          _withDirectives(_createElementVNode("div", { class: "dt__filter-button-selected" }, _toDisplayString(this.filters.countActive()), 513 /* TEXT, NEED_PATCH */), [
            [_vShow, this.filters.notEmpty()]
          ])
        ]),
        _createVNode(_component_filter_panel, {
          ref: "panel",
          onApply: $options.onApply,
          onReset: $options.onReset,
          filters: $props.filters
        }, {
          filters: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.filterComponents, (component) => {
              return (_openBlock(), _createBlock(_resolveDynamicComponent(component.component), _mergeProps(component.attr, { mode: "filter" }), null, 16 /* FULL_PROPS */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          active: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.filterComponents, (component) => {
              return (_openBlock(), _createBlock(_resolveDynamicComponent(component.component), _mergeProps(component.attr, { mode: "active" }), null, 16 /* FULL_PROPS */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onApply", "onReset", "filters"])
      ]))
    : _createCommentVNode("v-if", true)
}